import { useReducer } from 'react'

export function useForceUpdate(): () => void {
  const [, dispatchNoOp] = useReducer(() => ({}), {})
  return dispatchNoOp as () => void
}
